if (!customElements.get('variant-image')) {
  customElements.define(
    'variant-image',
    class VariantImage extends HTMLElement {
      constructor() {
        super();
        this.img = this.querySelector('.variant-image__img');
      }

      connectedCallback() {
        this.sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.unsubscribeVariantChange) {
          this.unsubscribeVariantChange();
        }
      }

      onVariantChange(event) {
        if (!event.data || event.data.sectionId !== this.sectionId) return;
        this.updateImage(event.data.variant);
      }

      updateImage(variant) {
        const image = variant && variant.featured_image;

        if (!this.img || !image || !image.src) {
          this.setAttribute('hidden', '');
          return;
        }

        const separator = image.src.indexOf('?') === -1 ? '?' : '&';

        this.img.removeAttribute('srcset');
        this.img.removeAttribute('sizes');
        this.img.setAttribute('src', `${image.src}${separator}width=800`);
        this.img.setAttribute('alt', image.alt || '');
        this.removeAttribute('hidden');
      }
    }
  );
}
